// assets/js/modules/coverSlideshow.js
// Auto-slideshow with overlapping opacity+blur crossfade transitions

const INTERVAL_MS = 650;

let _interval = null;

export function init() {
    const el = document.querySelector('.cover-slideshow');
    if (!el) return;

    const images = JSON.parse(el.dataset.images || '[]');
    if (images.length < 2) return;

    // Replace any existing img with two stacked layers
    el.querySelectorAll('.cover-slideshow__img').forEach(n => n.remove());

    const front = document.createElement('img');
    const back  = document.createElement('img');
    front.className = 'cover-slideshow__img cover-slideshow__img--in';
    back.className  = 'cover-slideshow__img cover-slideshow__img--out';

    // Preload all images
    images.forEach(src => { new Image().src = src; });

    let current = 0;
    front.src = images[current];
    el.append(front, back);

    // active: currently visible layer / incoming: hidden next layer
    let active   = front;
    let incoming = back;

    function tick() {
        current = (current + 1) % images.length;
        incoming.src = images[current];

        // Force reflow so the browser registers incoming's initial state
        void incoming.offsetWidth;

        // Simultaneous crossfade: active exits, incoming enters
        active.classList.replace('cover-slideshow__img--in',  'cover-slideshow__img--out');
        incoming.classList.replace('cover-slideshow__img--out', 'cover-slideshow__img--in');

        [active, incoming] = [incoming, active];
    }

    _interval = setInterval(tick, INTERVAL_MS);

    // Pause slideshow on link hover
    // const link = document.querySelector('.cover-slideshow-link');
    // if (link) {
    //     link.addEventListener('mouseenter', () => {
    //         clearInterval(_interval);
    //         _interval = null;
    //     });
    //     link.addEventListener('mouseleave', () => {
    //         if (!_interval) _interval = setInterval(tick, INTERVAL_MS);
    //     });
    // }
}

export function destroy() {
    clearInterval(_interval);
    _interval = null;
}
